<template>
  <!--设备功能设置组件-->
  <div id="EquipmentParam">
    <el-form style="margin:0px 10px 10px 0px;" id="diaForm" ref="diaForm">
      <el-row :gutter="24" >
        <el-col :span="12">

        </el-col>
        <el-col :span="12">
          <el-button type="primary" size="small" @click="pullData" style="margin-left: 15px;">
            <i class="el-icon-upload"></i>{{$t('equipmentmanagement.read')}}
          </el-button>
          <el-button size="small" @click="refreshData" style="margin-left: 15px;">
            <i class="el-icon-refresh-right el-icon--left"></i>{{$t('refresh')}}
          </el-button>
          <el-button type="info" style="margin-left: 15px;"  v-preventReClick @click="saveData">
            <i class="iconfont el-icon-baocun el-icon--left"></i>{{$t('save')}}
          </el-button>
          <el-button type="info" style="margin-left: 15px;"  v-preventReClick @click="cancelData">
            <i class="iconfont el-icon-quxiao el-icon--left"></i>{{$t('cancel')}}
          </el-button>
        </el-col>
      </el-row>
      <el-row
        v-if="initValue.equipmentType.id != 7"
        v-for="(item,index) in EquConfigList"
        :key="index"
        :gutter="24"
        style="margin-top: 10px"
        class="forDiv"
      >
        <!-- 特殊标注：variableName=SetSales_GEN*2#1 时背景色高亮 -->
        <div
          class="eqConfig-1f-div"
          :style="item.variableName === 'SetSales_GEN*2#1'
      ? 'width:90%;height:60px;background-color:#FF9800;margin:0 auto;border-radius:50px;border:2px solid #ff5722'
      : 'width:90%;height:60px;background-color:#FFE4C4;margin:0 auto;border-radius:50px'"
        >
          <el-col :span="7">
            <span style="line-height: 60px;margin-left: 20px;font-size: 16px">{{langFlag==0?item.name:item.englishName}} :</span>
          </el-col>

          <el-col :span="5">
            <span
              v-if="item.variableName === 'SetSales_GEN*2#1'"
              style="line-height:60px;font-size:16px;font-weight:bold"
            >
        {{ item.value }}
      </span>
            <el-input
              v-else
              v-model="item.value"
              @blur="validateData($event,item.name,item.variableName,item.maxValue,item.minValue)"
              class="inputMaybeChange"
              :ref="item.id"
              :id="item.id"
            ></el-input>
          </el-col>

          <el-col :span="5">
            <el-tooltip class="item" effect="dark" :content="item.introduction==''||item.introduction==null?'':'('+item.introduction+')'" placement="top-start">
              <span style="line-height: 60px;margin-left: 20px;font-size: 16px;display:block; word-break:keep-all; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">
                {{item.introduction == ''||item.introduction==null?'':'('+item.introduction+')'}}
              </span>
            </el-tooltip>
          </el-col>

          <el-col :span="3">
            <span style="line-height: 60px;font-size: 16px;color: blue;width:120px;display:block">{{$t('equipmentmanagement.currentValue')}}:{{item.currentValue}} </span>
          </el-col>

          <el-col :span="2" v-if="isAdmin">
            <span style="line-height: 60px;width:80px;display:block">{{$t('multiple')}}:</span>
          </el-col>

          <!-- 特殊项也隐藏 multiple 输入框 -->
          <el-col
            :span="2"
            style="float:right;right:10px"
            v-if="isAdmin && item.variableName !== 'SetSales_GEN*2#1'"
          >
            <el-input v-model="item.multiple"></el-input>
          </el-col>
        </div>
      </el-row>
</el-form>
  </div>
</template>

<script>
export default {
  name: "EquipmentParam",
  props:{
    initValue:null
  },
  data(){
    return{
      equpid:null,
      EquConfigList:[],
      langFlag:0,//语言选择0中文1英文
      totalEquConfigCount:0,
      needResolve:[],//暂存存在问题的输入框的数组
      isAdmin:false
    }
  },
  created() {
    this.isAdmin = this.$account.data.isAdmin
    this.loadEquipConfigList()
  },
  methods:{
    //获取设备参数信息
    loadEquipConfigList(){
      let that = this;
      this.$httpservice.get("api/Equipment/GetParameters?dtuNo="+that.initValue.dtuNumber).then(
        function (data) {
          if(data.body.code=="200"){
            console.log(that.initValue)
            let tempObj = data.body.data
            // 转换列表的格式
            tempObj.forEach(item => {
              // 如果是下拉
              if(item.dataType){
                if(item.preselectedValue){
                  // 按逗号分割
                  let options = item.preselectedValue.split(',')
                  item.options = options
                }
              }
            })
            that.EquConfigList = tempObj;
            that.totalEquConfigCount = data.body.totalCount;
          }else{
            that.$message({
              message: data.body.msg,
              type: 'danger'
            });
          }
        },

        function (data) {
          let statusCode = data.status;
          that.$message({
            message: that.$t('queryFailedStatusCode')+statusCode,
            type: 'warning'
          });
        }
      );
    },
    /**
     * 拉取数据
     */
    pullData(){
      let that = this
      this.reloading = this.openLoading(that.$t('equipmentmanagement.dataReading')+'......')
      this.$httpservice.get("api/Equipment/ReadEquipmentParameters",{equipmentId:this.initValue.id}).then(result => {
        if(result.data.code==200){
          setTimeout(function() { // 设定定时器，超时10S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题,使用时只需要提前设置定时器，然后关闭
            that.reloading.close() // 关闭遮罩层
            that.$message.success(that.$t('equipmentmanagement.readingSuccessfully'))
          }, 15000)
          this.loadEquipConfigList()
          return
        }else{
          this.$message.error(that.$t('equipmentmanagement.failedToReadParameters'))
          return
        }
        this.reloading.close()// 关闭loading框
      })
    },
    // 工具方法
    delArrayItem(array,item){
      const index = array.indexOf(item)
      if(index >-1){
        array.splice(index,1)
      }
    },
    checkArrayItem(array,item){
      const index = array.indexOf(item)
      if(index!=-1){
        return
      }else{
        array.push(item)
      }
    },
    // 重置输入框样式
    resetInputStyle(){
      let dom = document.querySelectorAll('.inputMaybeChange>input')
      for(let item in dom){
        if(dom[item].style){
          dom[item].style.backgroundColor = '#ffffff'
        }
      }
    },
    /**
     * 刷新数据
     */
    refreshData(){
      this.resetInputStyle()
      this.loadEquipConfigList()
    },
    // 保存数据
    saveData(){
      //判断是否存在空值
      for(let i in this.EquConfigList){
/*        try{
          if(this.EquConfigList[i].value==null || this.EquConfigList[i].value=='' || this.EquConfigList[i].value==undefined){
            this.checkArrayItem(this.needResolve,this.EquConfigList[i].name)
            let temp = this.EquConfigList[i].id
            if(this.$refs[''+temp+''][0]){
              this.$refs[''+temp+''][0].$refs.input.style.backgroundColor='#FFC0CB'
            }
          }else{
            let temp = this.EquConfigList[i].id
            if(this.$refs[''+temp+''][0]){
              this.$refs[''+temp+''][0].$refs.input.style.backgroundColor='#FFFFFF'
            }
          }
        }catch (e){
          console.warn('参数或节点存在异常！')
        }*/
        // 比较最大最小值
        let temp = this.EquConfigList[i]
        if(temp.maxValue>0){
          if(temp.maxValue<temp.value){
            this.$message.error("["+temp.name+"]不能大于最大值")
            return
          }
          if(temp.minValue > temp.value){
            this.$message.error("["+temp.name+"]不能小于最小值")
            return
          }
        }
      }
      //如果还存在未解决的问题，就不允许保存并提示
      if(this.needResolve.length!=0){
        let noticStr = '['
        for(let i =0;i<this.needResolve.length;i++){
          if(i!=this.needResolve.length-1){
            noticStr = noticStr + this.needResolve[i]+ ','
          }else{
            noticStr = noticStr + this.needResolve[i]
          }
        }
        noticStr = noticStr +']'+this.$t('equipmentmanagement.theInputValueIsIncorrect')+'！'
        this.$message.error(noticStr)
        return
      }
      let that = this
      this.reloading = this.openLoading(this.$t('equipmentmanagement.dataSavingPleaseWait')+'......')
      // 拼对象
      this.$httpservice.post('api/Equipment/BatchAddParameter',{equipmentParameterPostDatas:this.EquConfigList,equipment_ID:this.initValue.id}).then(result => {
        if(result.data.code=='200'){
          setTimeout(function() { // 设定定时器，超时10S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题,使用时只需要提前设置定时器，然后关闭
            that.reloading.close() // 关闭遮罩层
            that.$message.success(that.$t('saveSuccessfully'))
            that.loadEquipConfigList()
          }, 15000)
        }else{
          setTimeout(function() { // 设定定时器，超时10S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题,使用时只需要提前设置定时器，然后关闭
            that.reloading.close() // 关闭遮罩层
            that.$message.success(that.$t('saveFailed'))
          }, 15000)
        }
        //this.cancelData()
      })
    },
    //取消保存操作，并关闭父dialog
    cancelData(){
      this.$emit('cancelData')
    },
    /**
     * 校验数据
     */
    validateData(event,name,variableName,maxValue,minValue){
      let input = event.currentTarget
      // 获取当前输入框的value
      let value = event.target.value
      // 判断是否是空值
/*      if(!value){
        //判断是否存在同名参数，如果存在就不做操作，不存在就添加
        this.checkArrayItem(this.needResolve,name)
        this.$message.error('['+name+']'+this.$t('equipmentmanagement.cannotBeEmpty')+'！')
        input.style.backgroundColor = '#FFC0CB'
        return
      }else{
        this.delArrayItem(this.needResolve,name)
        input.style.backgroundColor = '#ffffff'
      }*/
      // 判断是否全是数字
/*      let reg = /^[^\s]+$/;
      if(!reg.test(value)){
        //判断是否存在同名参数，如果存在就不做操作，不存在就添加
        this.checkArrayItem(this.needResolve,name)
        this.$message.error('['+name+']'+this.$t('equipmentmanagement.pleaseEnterANumber')+this.$t('equipmentmanagement.pleaseEnterANumber')+'！')
        input.style.backgroundColor = '#FFC0CB'
        return
      }else{
        this.delArrayItem(this.needResolve,name)
        input.style.backgroundColor = '#ffffff'
      }*/
      if(value){
        if(maxValue){
          // 校验是否满足最大值和最小值
          if(maxValue != undefined){
            if(value>maxValue){
              //如果有问题，需要加入有问题的数组，需要弹窗提示以及样式变化
              this.checkArrayItem(this.needResolve,name)
              this.$message.error('['+name+']'+this.$t('equipmentmanagement.theInputParameterNeedsToBeLessThanTheMaximumValue'))
              input.style.backgroundColor = '#FFC0CB'
              return
            }else{
              this.delArrayItem(this.needResolve,name)
              input.style.backgroundColor = '#ffffff'
            }
          }else{
            input.style.backgroundColor = '#ffffff'
          }
          if(minValue != undefined){
            if(value<minValue){
              this.checkArrayItem(this.needResolve,name)
              this.$message.error('['+name+']'+this.$t('equipmentmanagement.theInputParameterNeedsToBeGreaterThanTheMinimumValue'))
              input.style.backgroundColor = '#FFC0CB'
              return
            }else{
              this.delArrayItem(this.needResolve,name)
              input.style.backgroundColor = '#ffffff'
            }
          }else{
            input.style.backgroundColor = '#ffffff'
          }
        }

      }
    },
  },
  watch:{
    initValue(val, oldVal){//监听设备选择
      if(val!=oldVal){
        this.equpid = this.initValue;
      }
    },
  }
}
</script>

<style lang="less">
  #EquipmentParam{
    .forDiv{
      .el-col{
        height: 1px;
      }
    }
    .eqConfig-1f-div{
      line-height: 60px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/equipmentmanagement/EquipmentParam.vue